import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "@libs/rubick";
import { formatUsageValue } from "@/utils/formatters";
import { shortApiKey } from "./utils";
import { UsageTimelineChart } from "./UsageTimelineChart";
function SelectedApiKeyUsage({ lastUsedAt, selectedApiKey, selectedApiKeyDetails, totalRequests, totalUsageValue, trendPoints, usageUnit }) {
    return /*#__PURE__*/ _jsxs(Card, {
        variant: "bordered",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-4 flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs("h2", {
                                className: "text-lg font-semibold text-gray-900",
                                children: [
                                    selectedApiKeyDetails?.name || "Selected API Key",
                                    " - Usage Over Time"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mt-1 text-sm text-gray-500",
                                children: "Refreshes every 5 minutes"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "rounded-lg border border-blue-200 bg-blue-50 px-3 py-1 text-xs text-blue-700",
                        children: shortApiKey(selectedApiKey)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-1 gap-6 xl:grid-cols-[1fr_280px]",
                children: [
                    /*#__PURE__*/ _jsx(UsageTimelineChart, {
                        points: trendPoints,
                        usageUnit: usageUnit
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rounded-xl border border-gray-200 bg-gray-50 p-4",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs font-semibold uppercase tracking-wider text-gray-500",
                                children: "Key Stats"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mt-4 space-y-4",
                                children: [
                                    /*#__PURE__*/ _jsx(KeyStat, {
                                        label: "Total Usage",
                                        value: formatUsageValue(totalUsageValue, usageUnit),
                                        large: true
                                    }),
                                    /*#__PURE__*/ _jsx(KeyStat, {
                                        label: "Requests",
                                        value: totalRequests.toLocaleString(),
                                        large: true
                                    }),
                                    /*#__PURE__*/ _jsx(KeyStat, {
                                        label: "Last Used",
                                        value: lastUsedAt ? lastUsedAt.toUTCString() : "No recent activity"
                                    }),
                                    /*#__PURE__*/ _jsx(KeyStat, {
                                        label: "Created",
                                        value: selectedApiKeyDetails?.createdDate ? new Date(selectedApiKeyDetails.createdDate).toUTCString() : "-"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function KeyStat({ label, large = false, value }) {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-xs font-semibold uppercase tracking-wider text-gray-500",
                children: label
            }),
            /*#__PURE__*/ _jsx("p", {
                className: large ? "mt-1 text-2xl font-semibold text-gray-900" : "mt-1 text-base font-medium text-gray-900",
                children: value
            })
        ]
    });
}
export { SelectedApiKeyUsage };
